export const emarPriceTable = {
  0: 12,
  1: 12,
  2: 18,
  3: 24,
  4: 28,
  5: 30,
  6: 32,
  7: 35,
  8: 38,
  9: 39,
  10: 40,
  11: 41,
  12: 42,
  13: 43,
  14: 44,
  15: 45,
  16: 46,
  17: 47,
  18: 48,
  19: 49,
  20: 50,
  21: 51,
  22: 53,
  23: 55,
  24: 58,
  25: 60,
  26: 62,
  27: 65,
  28: 67,
  29: 69,
  30: 71,
  31: 73,
  32: 74,
  33: 76,
  34: 78,
  35: 81,
  36: 83,
  37: 85,
  38: 87,
  39: 90,
  40: 92,
  41: 94,
  42: 97,
  43: 99,
  44: 101,
  45: 103,
  46: 106,
  47: 108,
  48: 110,
  49: 113,
  50: 115,
}

export const proPriceTableMonthly = {
  0: 35,
  1: 35,
  2: 50,
  3: 63,
  4: 72,
  5: 80,
  6: 86,
  7: 91,
  8: 94,
  9: 97,
  10: 100,
  11: 105,
  12: 110,
  13: 117,
  14: 126,
  15: 135,
  16: 144,
  17: 153,
  18: 160,
  19: 164,
  20: 168,
  21: 172,
  22: 176,
  23: 184,
  24: 192,
  25: 200,
  26: 208,
  27: 216,
  28: 224,
  29: 232,
  30: 240,
  31: 248,
  32: 256,
  33: 264,
  34: 272,
  35: 280,
  36: 288,
  37: 296,
  38: 304,
  39: 308,
  40: 312,
  41: 316,
  42: 319,
  43: 323,
  44: 326,
  45: 329,
  46: 331,
  47: 334,
  48: 338,
  49: 344,
  50: 350,
}

export const familyPriceTableMonthly = {
  0: 10,
  1: 10,
  2: 14,
  3: 19,
  4: 22,
  5: 24,
  6: 25,
  7: 28,
  8: 30,
  9: 31,
  10: 32,
  11: 33,
  12: 34,
  13: 34,
  14: 35,
  15: 36,
  16: 37,
  17: 38,
  18: 38,
  19: 39,
  20: 40,
  21: 41,
  22: 42,
  23: 44,
  24: 46,
  25: 48,
  26: 50,
  27: 52,
  28: 54,
  29: 55,
  30: 57,
  31: 58,
  32: 59,
  33: 61,
  34: 63,
  35: 64,
  36: 66,
  37: 68,
  38: 70,
  39: 72,
  40: 74,
  41: 75,
  42: 77,
  43: 79,
  44: 81,
  45: 83,
  46: 85,
  47: 86,
  48: 88,
  49: 90,
  50: 92,
}
